

exports.__esModule = true;
exports.$SidebarAddCardRoute = undefined;

var _squid = require('squid');

require('xo-wallet-components/src/add-card/route');

require('./directive');

var $SidebarAddCardRoute = exports.$SidebarAddCardRoute = _squid.$ComponentRoute.extend('$SidebarAddCardRoute', {
    path: 'sidebarAddCard',
    directive: 'xo-sidebar-add-card-page',
    titleContent: 'asideHeader.addCard',
    trackingData: {
        templateName: 'tray/addCard.dust',
        pageGoal: 'Add Card',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-cc',
                'pagename2': '%::fullpage-add-cc:member:hermes:tray',
                'version': 'member:%:tray'
                // More page qualifiers come here...
            } }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            sidebar: 'sidebar',
            'back-uri': 'backUri',
            'parent-callbacks': 'callbacks',
            promotion: 'promotion'
        }
    }]
});

angular.value("$SidebarAddCardRoute", $SidebarAddCardRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-sidebar-add-card/route.js
// module id = ./pages/xo-sidebar-add-card/route.js
// module chunks = 0